import React from 'react';
import type { RemainingCounter } from '../utils/counters';
import { formatNumber } from '../utils/format';
interface RemainingCountersProps {
  items: RemainingCounter[];
}

/** "How many more times" — bodily units against abstract weeks. */
export function RemainingCounters({
  items
}: RemainingCountersProps) {
  const gains = items.filter(item => item.tone !== 'loss');
  const losses = items.filter(item => item.tone === 'loss');
  return <div className="flex flex-wrap items-baseline gap-x-7 gap-y-2 sm:gap-x-9" data-id="element-96" data-mp="3gwdv76txb5gt">
      <span className="text-muted text-[11px]" data-id="element-97" data-mp="3kwxn9vzn3iw3">still to come</span>

      {gains.map(item => <span key={item.id} className="flex items-baseline gap-1.5" data-id="element-98" data-mp="3pyn1fki5scoe">
          <span className="text-ink font-mono text-sm tabular-nums" data-id="element-99" data-mp="3uwy9bpow8d3z">{formatNumber(item.value)}</span>
          <span className="text-muted text-[11px]" data-id="element-100" data-mp="1vk3zpk5fyd7f">{item.label}</span>
        </span>)}

      {losses.map(item => <span key={item.id} className="text-muted flex items-baseline gap-1.5 text-[11px]" data-id="element-101" data-mp="20j6umbrpj31o">
          <span className="text-faint" data-id="element-102" data-mp="2zggddh2x2zxg">·</span>
          <span data-id="element-103" data-mp="2zhizzct7ig7k">
            <span className="mr-1.5 font-mono text-sm tabular-nums line-through decoration-1" data-id="element-104" data-mp="2up82eglxv6i6">
              {formatNumber(item.value)}
            </span>
            {item.label}
          </span>
        </span>)}
    </div>;
}